export { default } from './RightPagination'
